import { styled } from 'theme'

export const StyledRealEstateSearchBar = styled.div`
  /* background-color: white;
  color: blue;
  padding: 1rem; */
`
